const TIME_STATS = [
  'stats.avgLos',
  'stats.medianLos',
  'stats.los',
  'stats.avgLoc',
  'stats.medianLoc',
  'stats.loc',
  'stats.avgLof',
  'stats.medianLof',
  'stats.lof',
  'stats.avgDaysLost',
  'stats.mediumDaysLost',
  'stats.daysLost',
  'stats.avgDaysAvailable',
  'stats.medianDaysAvailable',
  'stats.daysAvailable',
  'stats.avgLengthSuppport',
  'stats.medianLengthSuppport',
];

export { TIME_STATS };
